import { packageByStatus, usePackageProjectRemoval } from 'entities';

import { IconButton } from 'components/Blocks';
import { RemoveProjectIcon } from 'components/Icons';

import { useCommon } from 'hooks/common';
import { usePackage } from './context';

import { listGet, listRemove } from 'utils/array';

interface RemoveProjectButtonProps {
  projectId: string;
}

export function RemoveProjectButton({ projectId }: RemoveProjectButtonProps): JSX.Element | null {
  const { t, user } = useCommon();

  const { data, overwrite } = usePackage();

  const { removeProjectFromPackage } = usePackageProjectRemoval({
    onSuccess: ({ projectId }) =>
      overwrite((old) => {
        const toRemove = listGet(old.projects, projectId, ({ project }) => project.id)!;

        const amountAvailable = Number(old.amountAvailable) + Number(toRemove.value);

        return {
          ...old,
          projects: listRemove(old.projects, projectId, ({ project }) => project.id),
          amountAvailable: amountAvailable.toFixed(2),
        };
      }),
  });

  const canRemove = [
    user.type == 'LEADER',
    user.team.isInvoiceTeam,
    packageByStatus[data.status].canRemoveProject,
  ].every(Boolean);

  if (!canRemove) return null;

  return (
    <IconButton
      tooltipContent={t('detach-project-from-package')!}
      onClick={() =>
        removeProjectFromPackage({
          projectId,
          packageId: data.id,
        })
      }
    >
      <RemoveProjectIcon size={16} color="destructive" />
    </IconButton>
  );
}
